import { axios } from '@/utils/request'

export function queryMyDepartTreeList(params){
    return axios({
        url: '/sys/sysDepart/queryMyDeptTreeList',
        params: params
    })
}